import React, { useEffect, useState } from 'react'
import { Item } from '../../../../common/snippets'
import { Box, Button, Tab, Tabs } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../../common/dropDownOA'
import ReportTable from './ReportTable'
import { connect } from 'react-redux'
import { updateModal, getBranchListAndCityList, updateAlertError } from '../../../../../store/common/common_action'
import * as mdt from '../../../../common/modaltypes'
import PIckUpAndDropoffModal from './PIckUpAndDropoffModal'
import { selectChargeOpt } from './PIckUpAndDropoffConstant'
import { focusElemnt, isEmpty, navigation3 } from '../../../../common/helper'
import { getPickUpAndDropOff, getPickupDropoffChargeSlab, updatePickUpAndDropOffCharge } from '../../../../../store/generalSetting/GSAction'
import ConfirmModal from './ConfirmModal'
import { useRef } from 'react';
import PIckUpAndDropoffModalKgKm from './PIckUpAndDropoffModalkgkm';
const PickupAndDropoffCharge = (props) => {
  const { data: { common, generalSettingReducer },
    updateModal,
    getPickUpAndDropOff,
    getBranchListAndCityList,
    updateAlertError,
    getPickupDropoffChargeSlab,
    updatePickUpAndDropOffCharge
  } = props
  const { loginData, roleRights, showModal, modalType } = common
  const { pickUpAndDropoff } = generalSettingReducer
  const [selectCharge, setSelectCharge] = useState(selectChargeOpt[0])
  const [reportData, setReportData] = useState([])
  const [branchAndCityOpt, setBranchAndCityOpt] = useState([])
  const [existBranchAndCity, setExistBranchAndCity] = useState([])
  const [chargeTypeTab, setChargeTypeTab] = useState(0)

  const showPickupAndDropoffModal = () => {
    const data = {
      loginData: loginData,
      isUpdate: false,
      headText: "Add Pickup / Dropoff Charge",
      branchAndCityOpt: branchAndCityOpt
    }
    return <PIckUpAndDropoffModal data={data} updateModal={updateModal} updateAlertError={updateAlertError} getPickupDropoffChargeSlab={getPickupDropoffChargeSlab} updatePickUpAndDropOffCharge={updatePickUpAndDropOffCharge} generatePickUpAndDropOff={generatePickUpAndDropOff} />
  }
  const showUpdatePickUpAndDropoffModal = () => {
    const data = {
      loginData: loginData,
      isUpdate: true,
      headText: "Edit Pickup / Dropoff Charge",
      branchAndCityOpt: existBranchAndCity
    }
    return <PIckUpAndDropoffModal data={data} updateModal={updateModal} updateAlertError={updateAlertError} getPickupDropoffChargeSlab={getPickupDropoffChargeSlab} updatePickUpAndDropOffCharge={updatePickUpAndDropOffCharge} generatePickUpAndDropOff={generatePickUpAndDropOff} />
  }
  const showPIckUpAndDropoffModalKgKm = () => {
    const data = {
      loginData: loginData,
      isUpdate: true,
      headText: "Edit Pickup / Dropoff Charge",
      branchAndCityOpt: existBranchAndCity
    }
    return <PIckUpAndDropoffModalKgKm data={data} updateModal={updateModal} updateAlertError={updateAlertError} getPickupDropoffChargeSlab={getPickupDropoffChargeSlab} updatePickUpAndDropOffCharge={updatePickUpAndDropOffCharge} generatePickUpAndDropOff={generatePickUpAndDropOff} />
  }

  useEffect(() => {
    focusElemnt("Select_Charge")
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData) && loginData?.intCompanyID) {
      getBranchList()
    }
  }, [loginData])
  useEffect(() => {
    let newData = [...pickUpAndDropoff]
    setReportData(newData)
    setExistBranchAndCity(branchAndCityOpt.filter((val) => [...newData.map((obj) => obj.BranchID)].includes(val.BranchID)))
  }, [pickUpAndDropoff])
  const getBranchList = () => {
    const obj = {
      intUserID: 0,
      intCompanyID: loginData?.intCompanyID,
      intBranchID: 0,
      strBranchName: '',
      strBranchCode: '',
      intStateID: 0,
      intCityID: 0,
      intIsActive: -1,
    }
    getBranchListAndCityList(obj, true, 24 * 60 * 60 * 1000).then((res) => {
      if (res.status === 'Success') {
        setBranchAndCityOpt(res.Data.Table)
        generatePickUpAndDropOff()
      } else {
        setBranchAndCityOpt([])
        updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
      }
    }).catch((err) => {
      setBranchAndCityOpt([])
    })

  }
  const generatePickUpAndDropOff = () => {
    const body = {
      CompanyID: loginData?.intCompanyID,
      BranchID: 0,
      Mode: selectCharge?.id
    }
    getPickUpAndDropOff(body)
  }
  return (
    <>
      <Tabs
        sx={{ borderBottom: 1, borderColor: 'divider', minHeight: 'unset' }}
        value={chargeTypeTab}
        onChange={(event, newValue) => setChargeTypeTab(newValue)}
        aria-label="basic tabs example"
      >
        <Tab sx={{ minHeight: '40px', fontSize: '16px' }} label="Per KG/ Per Unit" aria-label="basic tabs example" />
        {/* <Tab sx={{ minHeight: '40px', fontSize: '16px' }} label="Per KG Per KM/ Per Unit Per KM" aria-label="basic tabs example" /> */}
        {/* <Tab
            sx={{ minHeight: '40px', fontSize: '16px', maxWidth: 'unset' }}
            label="Per KG Per KM Per Unit/ Per Unit Per KM Per KG"
            aria-label="basic tabs example"
          /> */}
      </Tabs>
      {chargeTypeTab === 0 && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px' }}>
            <Box sx={{ display: 'flex', gap: '16px' }} className="reportButtons">
              {/* <Item sx={sx.itemsx}>
                  <DropDownOA id={'Select_comapny'} label={'Select Company'} minWidth="250px" />
                </Item>
                <Item sx={sx.itemsx}>
                  <DropDownOA id={'Select_branch'} label={'Select Branch'} minWidth="250px" />
                </Item> */}
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'Select_Charge'}
                  label={'Select Charge'}
                  data={selectChargeOpt || []}
                  defaultvalue={selectCharge?.name || ''}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelect={(val) => {
                    setSelectCharge(val)
                  }}
                  minWidth="200px"
                  nextId={'search_btn'}
                  prevId={`index-9`}
                />
              </Item>
              {/* <Item sx={sx.itemsx}>
                  <DropDownOA id={'select_charge_type'} label={'Select Charge Type'} minWidth="150px" />
                </Item> */}
              <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                <Button
                  variant="contained"
                  onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Charge', () => { })}
                  id={'search_btn'}
                  sx={{ width: '100%', paddingY: '6px !important' }}
                  className="btn btn-primary"
                  onClick={() => generatePickUpAndDropOff()}
                >
                  SEARCH
                </Button>
              </Item>
              <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
                <Button
                  variant="outlined"
                  id={'add_btn'}
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onKeyDown={(e) => navigation3(e, 'editExisting', 'search_btn', () => { })}
                  onClick={() => {
                    updateModal(true, mdt.PickupAndDropoffModal)
                  }}
                >
                  + ADD NEW
                </Button>
              </Item>
              <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  id="editExisting"
                  className="receiveitembtn"
                  onKeyDown={(e) => navigation3(e, 'index-1', 'add_btn', () => { })}
                  onClick={() => {
                    updateModal(true, mdt.UpdatePickupAndDropoffModal)
                  }}
                >
                  EDIT EXISTING
                </Button>
              </Item>
            </Box>
          </Box>

          <Box sx={{ marginTop: '15px' }}>
            <ReportTable reportData={reportData} />
          </Box>
        </>
      )}
      {chargeTypeTab === 1 && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px' }}>
            <Box sx={{ display: 'flex', gap: '16px' }} className="reportButtons">
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'Select_Charge'}
                  label={'Select Company'}
                  data={selectChargeOpt || []}
                  defaultvalue={selectCharge?.name || ''}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelect={(val) => {
                    setSelectCharge(val)
                  }}
                  minWidth="250px"
                  nextId={'search_btn'}
                  prevId={`index-9`}
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'Select_Charge'}
                  label={'Select Branch'}
                  data={selectChargeOpt || []}
                  defaultvalue={selectCharge?.name || ''}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelect={(val) => {
                    setSelectCharge(val)
                  }}
                  minWidth="250px"
                  nextId={'search_btn'}
                  prevId={`index-9`}
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'Select_Charge'}
                  label={'Select Charge'}
                  data={selectChargeOpt || []}
                  defaultvalue={selectCharge?.name || ''}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelect={(val) => {
                    setSelectCharge(val)
                  }}
                  minWidth="250px"
                  nextId={'search_btn'}
                  prevId={`index-9`}
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'Select_Charge'}
                  label={'Select Charge type'}
                  data={selectChargeOpt || []}
                  defaultvalue={selectCharge?.name || ''}
                  idKey={`id`}
                  dataKey={`name`}
                  onSelect={(val) => {
                    setSelectCharge(val)
                  }}
                  minWidth="250px"
                  nextId={'search_btn'}
                  prevId={`index-9`}
                />
              </Item>
              <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                <Button
                  variant="contained"
                  onKeyDown={(e) => navigation3(e, 'add_btn', 'Select_Charge', () => { })}
                  id={'search_btn'}
                  sx={{ width: '100%', paddingY: '6px !important' }}
                  className="btn btn-primary"
                  onClick={() => generatePickUpAndDropOff()}
                >
                  SEARCH
                </Button>
              </Item>
              <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
                <Button
                  variant="outlined"
                  id={'add_btn'}
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  startIcon={<CloudUploadIcon />}
                  onKeyDown={(e) => navigation3(e, 'editExisting', 'search_btn', () => { })}
                  onClick={() => {
                    updateModal(true, mdt.PickupAndDropoffModal)
                  }}
                >
                  UPLOAD
                </Button>
              </Item>
              <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                <Button
                  variant="outlined"
                  sx={{ width: '100%' }}
                  id="editExisting"
                  className="receiveitembtn"
                  onKeyDown={(e) => navigation3(e, 'index-1', 'add_btn', () => { })}
                  onClick={() => {
                    updateModal(true, mdt.UpdatePickupAndDropoffModalkgkm)
                  }}
                >
                  EDIT EXISTING
                </Button>
              </Item>
            </Box>
          </Box>

          <Box sx={{ marginTop: '15px' }}>
            <ReportTable reportData={reportData} coloumndef={2} />
          </Box>
        </>
      )}
      {showModal && mdt.PickupAndDropoffModal === modalType ? showPickupAndDropoffModal() : null}
      {showModal && mdt.UpdatePickupAndDropoffModal === modalType ? showUpdatePickUpAndDropoffModal() : null}
      {showModal && mdt.UpdatePickupAndDropoffModalkgkm === modalType ? showPIckUpAndDropoffModalKgKm() : null}
      {showModal && mdt.pickupAndDropOffConfModal === modalType ? <ConfirmModal updateModal={updateModal} /> : null}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getPickUpAndDropOff, getBranchListAndCityList, updateAlertError, getPickupDropoffChargeSlab, updatePickUpAndDropOffCharge }
export default connect(mapStateToProps, mapDispatchToProps)(PickupAndDropoffCharge)
